<template>
    <div class="folder-list-wrapper">
        <div class="folder-list">
            <div :class="classList(folder.id)" class="folder" v-for="folder in folders" :key="'folder' + folder.id">

                <modal title="Edit Folder Name" :ref="'folderModal'+folder.id" :hide_button="true">
                    <edit-folder-name :folder-id="folder.id" :name="folder.name"></edit-folder-name>
                </modal>

                <span v-if="folder != null" class="folder-title" @click="$store.dispatch('selectFolder', folder.id)">{{folder.name}}</span>
                <div class="btn-group" v-if="!isCoreFolder(folder) && canCreateFolder()" v-can="buildPermission('edit folders,delete folders')">
                    <span class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        ...
                    </span>
                    <div class="dropdown-menu">
                        <button class="dropdown-item" type="button" @click="openModal($event, 'folderModal'+folder.id)" v-can="buildPermission('edit folders')">Edit Folder Name</button>
                        <button class="dropdown-item" type="button" @click="$store.dispatch('deleteFolder', folder.id)" v-can="buildPermission('delete folders')">Delete</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="folder-list-options">
            <a class="btn btn-sm btn-secondary text-white" v-if="isRoot" @click="$store.dispatch('back')">Back</a>
            <a class="btn btn-sm btn-secondary text-white" v-if="isRoot" @click="$store.commit('openSidebar', true)">View Basket</a>
            <modal button_content="+ Add Folder" button_class="btn btn-sm btn-secondary" title="New Folder" v-if="canCreateFolder()" v-can="buildPermission('create folders')">
                <new-folder :parent-id="parentId"></new-folder>
            </modal>
        </div>
    </div>
</template>

<script>
    import NewFolder from './Forms/NewFolder';
    import EditFolderName from "./Forms/EditFolderName";
    import { mapGetters, mapState } from 'vuex';

    export default {
        components: {EditFolderName, NewFolder},

        props: {
            folders: [Object,Array],
            parentId: Number,
            isRoot: Boolean
        },
        methods: {
            classList: function(id){
                return {
                    'folder-selected': this.currentFolderID == id
                }
            },
            openModal(e, name){
                this.$refs[name][0].showModal(e);
            },

            isCoreFolder(folder){
                return folder.job_id == null && folder.job_type != null;
            },

            canCreateFolder(){
                if(this.isDisabled){
                    return false;
                }

                let currentFolder = this.allFolders[this.currentFolderID];
                if(currentFolder != undefined) {
                    let job_type_name = currentFolder.job_type_name == 'N/A' ? null : currentFolder.job_type_name;
                    let folder_category = currentFolder.folder_category == 'central' ? null : currentFolder.folder_category;
                    if (
                        (job_type_name == this.jobType && folder_category == job_type_name) ||
                        (this.isRoot && folder_category != job_type_name)
                    ) {
                        return true;
                    }
                }

                return (this.isRoot && this.currentFolderID == null);
            }
        },

        computed: {
            ...mapState({
                jobType: 'job_type',
                allFolders: 'folders',
                currentFolderID: 'currentFolderID',
                isDisabled: 'isDisabled'
            }),

            ...mapGetters({
                buildPermission: 'buildPermission'
            })
        }
    }
</script>
